/* ===== SCHALTER Reservierungs-Timer („Dein Warenkorb ist 10:00 Min. reserviert“) =====
   true = an, false = aus. Zum Abschalten zusätzlich in snippets/tibetia-cart-progress.liquid
   `assign cart_timer_enabled = false` setzen (dann gibt es auch kein Markup). Beides = Timer komplett weg. */
var TIBETIA_CART_TIMER = false;

/* Tibetia · Warenkorb-Fortschritt + Empfehlungen
   - <tibetia-cart-progress>: animiert den Balken vom letzten Stand zum neuen (Dawn ersetzt das HTML bei jeder Änderung)
   - [data-tcu-add]: legt einen Artikel per /cart/add.js in den Warenkorb und rendert Drawer bzw. /cart über die
     Section Rendering API des Themes neu (gleicher Mechanismus wie Dawns Produktformular / cart.js). */
(function () {
  if (window.TibetiaCart) return;

  var memory = {};
  // true, während bereits vorhandene Elemente beim Laden der Seite „hochgestuft“ werden:
  // dann bleibt der vom Server gerenderte Stand stehen (kein Zurückspringen auf 0).
  var upgradingOnLoad = false;
  var ERROR_TEXT = 'Das hat leider nicht geklappt. Bitte versuch es noch einmal.';

  function reduceMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  // Dawn legt PUB_SUB_EVENTS als globale const an (nicht als window-Eigenschaft)
  function pubEvents() {
    try {
      /* global PUB_SUB_EVENTS */
      return typeof PUB_SUB_EVENTS !== 'undefined' ? PUB_SUB_EVENTS : window.PUB_SUB_EVENTS;
    } catch (e) {
      return window.PUB_SUB_EVENTS;
    }
  }

  function rootUrl() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function parseHTML(html, selector) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    return doc.querySelector(selector);
  }

  function showError(trigger, message) {
    var scope = trigger.closest('.tcu__card') || trigger.closest('tibetia-cart-progress');
    var el = scope && scope.querySelector('[data-tcu-error]');
    if (!el) return;
    el.textContent = message || ERROR_TEXT;
    el.hidden = false;
  }

  function renderPage(cartItems, data) {
    cartItems.getSectionsToRender().forEach(function (section) {
      var host = document.getElementById(section.id);
      var html = data.sections && data.sections[section.section];
      if (!host || !html) return;
      var target = host.querySelector(section.selector) || host;
      var source = parseHTML(html, section.selector);
      if (source) target.innerHTML = source.innerHTML;
    });
    var footer = document.getElementById('main-cart-footer');
    if (footer) footer.classList.remove('is-empty');
    cartItems.classList.remove('is-empty');
  }

  function add(trigger) {
    if (!trigger || trigger.getAttribute('aria-disabled') === 'true') return;
    var variantId = Number(trigger.dataset.variantId);
    if (!variantId) return;
    var properties = null;
    if (trigger.dataset.tcuProperties) {
      try { properties = JSON.parse(trigger.dataset.tcuProperties); } catch (e) { properties = null; }
    }
    var line = { id: variantId, quantity: 1 };
    if (properties) line.properties = properties;

    var drawer = trigger.closest('cart-drawer');
    var cartItems = drawer ? null : document.querySelector('cart-items');
    var sections = [];
    if (drawer && typeof drawer.getSectionsToRender === 'function') {
      sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
    } else if (cartItems && typeof cartItems.getSectionsToRender === 'function') {
      sections = cartItems.getSectionsToRender().map(function (s) { return s.section; });
    }

    var scope = trigger.closest('.tcu__card') || trigger.closest('tibetia-cart-progress');
    var errorEl = scope && scope.querySelector('[data-tcu-error]');
    if (errorEl) { errorEl.hidden = true; errorEl.textContent = ''; }

    trigger.setAttribute('aria-disabled', 'true');
    trigger.setAttribute('aria-busy', 'true');
    trigger.classList.add('is-loading');

    fetch(rootUrl() + 'cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({
        items: [line],
        sections: sections,
        sections_url: window.location.pathname
      })
    })
      .then(function (response) {
        return response.json().then(function (data) { return { ok: response.ok, data: data }; });
      })
      .then(function (result) {
        var data = result.data || {};
        if (!result.ok || data.status) {
          throw new Error(data.description || data.message || ERROR_TEXT);
        }
        if (drawer && typeof drawer.renderContents === 'function' && data.sections) {
          drawer.classList.remove('is-empty');
          drawer.renderContents(data);
        } else if (cartItems && data.sections) {
          renderPage(cartItems, data);
        } else {
          window.location.href = rootUrl() + 'cart';
          return;
        }
        if (typeof window.publish === 'function' && pubEvents()) {
          // 'cart-items' verhindert doppeltes Nachladen derselben Bereiche; ein Drawer auf /cart lädt sich selbst neu.
          var source = !drawer && document.querySelector('cart-drawer') ? 'tibetia-upsell' : 'cart-items';
          window.publish(pubEvents().cartUpdate, { source: source, cartData: data, variantId: variantId });
        }
        timerRefresh();
        var progress = document.querySelector(drawer ? 'cart-drawer tibetia-cart-progress' : 'cart-items tibetia-cart-progress');
        if (progress) progress.focus({ preventScroll: true });
      })
      .catch(function (error) {
        trigger.removeAttribute('aria-disabled');
        trigger.removeAttribute('aria-busy');
        trigger.classList.remove('is-loading');
        var msg = error && error.message && !/failed to fetch|networkerror|load failed/i.test(error.message) ? error.message : ERROR_TEXT;
        showError(trigger, msg);
      });
  }

  /* Karussell-Pfeile (Desktop) */
  function updateArrows(list) {
    var box = list && list.closest('tibetia-cart-upsell');
    if (!box) return;
    var prev = box.querySelector('[data-tcu-scroll="-1"]');
    var next = box.querySelector('[data-tcu-scroll="1"]');
    if (!prev || !next) return;
    var max = list.scrollWidth - list.clientWidth - 2;
    prev.disabled = list.scrollLeft <= 2;
    next.disabled = list.scrollLeft >= max;
  }

  document.addEventListener('click', function (event) {
    var arrow = event.target.closest && event.target.closest('[data-tcu-scroll]');
    if (arrow) {
      var list = arrow.closest('tibetia-cart-upsell').querySelector('.tcu__list');
      var card = list && list.querySelector('.tcu__card');
      if (list && card) {
        var step = (card.getBoundingClientRect().width + 10) * Number(arrow.dataset.tcuScroll);
        list.scrollBy({ left: step, behavior: reduceMotion() ? 'auto' : 'smooth' });
      }
      return;
    }
    var trigger = event.target.closest && event.target.closest('[data-tcu-add]');
    if (!trigger) return;
    event.preventDefault();
    add(trigger);
  });

  document.addEventListener(
    'scroll',
    function (event) {
      var t = event.target;
      if (t && t.classList && t.classList.contains('tcu__list')) updateArrows(t);
    },
    true
  );

  if (!customElements.get('tibetia-cart-progress')) {
    upgradingOnLoad = true;
    customElements.define(
      'tibetia-cart-progress',
      class extends HTMLElement {
        connectedCallback() {
          var key = this.dataset.context || 'default';
          var target = parseFloat(this.dataset.progress) || 0;
          var reached = (this.dataset.reached || '').split(',').filter(Boolean);
          var prev = memory[key];
          memory[key] = { progress: target, reached: reached };

          var fill = this.querySelector('[data-tcp-fill]');
          if (!fill || reduceMotion()) return;
          if (!prev && upgradingOnLoad) return;

          var start = prev ? prev.progress : 0;
          if (start !== target) {
            fill.style.transition = 'none';
            fill.style.setProperty('--tcp-p', String(start));
            void fill.offsetWidth;
            fill.style.transition = '';
            requestAnimationFrame(function () {
              fill.style.setProperty('--tcp-p', String(target));
            });
            if (target > start) this.classList.add('tcp--rising');
          }

          if (!prev) return;
          var self = this;
          reached
            .filter(function (r) { return prev.reached.indexOf(r) === -1; })
            .forEach(function (r) {
              var m = self.querySelector('[data-tcp-milestone="' + r + '"]');
              if (m) m.classList.add('is-celebrating');
            });
        }
      }
    );
    upgradingOnLoad = false;
  }

  if (!customElements.get('tibetia-cart-upsell')) {
    customElements.define(
      'tibetia-cart-upsell',
      class extends HTMLElement {
        connectedCallback() {
          var list = this.querySelector('.tcu__list');
          if (list) requestAnimationFrame(function () { updateArrows(list); });
        }
      }
    );
  }

  /* Nach einem eigenen /cart/add.js (z. B. Raunacht-Angebotsseite): Drawer frisch rendern und öffnen.
     Liefert ein Promise; wird abgelehnt, wenn kein Drawer existiert (dann bitte auf /cart weiterleiten). */
  function openDrawer() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || typeof drawer.renderContents !== 'function' || typeof drawer.getSectionsToRender !== 'function') {
      return Promise.reject(new Error('Kein Warenkorb-Drawer vorhanden'));
    }
    var ids = drawer.getSectionsToRender().map(function (s) { return s.id; });
    // Wichtig: KEIN „Accept: application/json“ – sonst liefert Shopify die Express-Kasse leer aus
    return fetch(rootUrl() + '?sections=' + ids.join(','), { credentials: 'same-origin' })
      .then(function (response) {
        if (!response.ok) throw new Error('Status ' + response.status);
        return response.json();
      })
      .then(function (sections) {
        if (!sections || !sections['cart-drawer']) throw new Error('Drawer-Inhalt fehlt');
        drawer.classList.remove('is-empty');
        drawer.renderContents({ sections: sections });
      });
  }

  /* ================= Gratis-Kalender automatisch hinzufügen / entfernen =================
     Regeln (Einstellungen kommen aus snippets/tibetia-cart-progress.liquid, part 'config'):
     - Warenkorbwert OHNE Kalender ≥ Schwelle, Aktion aktiv, Kalender verfügbar → Kalender mit Property
       _tibetia_geschenk=auto hinzufügen (der automatische Rabatt macht ihn 0 €).
     - Wert fällt unter die Schwelle → nur den AUTO-Kalender entfernen (gekaufte Kalender ohne Property nie).
     - Kundin entfernt den Auto-Kalender bewusst → Merker 'declined' (sessionStorage), kein erneutes Hinzufügen,
       bis der Wert unter die Schwelle fällt; bis dahin Knopf „Geschenk wieder hinzufügen“.
     - Gekaufter Kalender im Warenkorb → kein zweiter (vorhandener Auto-Kalender wird entfernt).
     - Höchstens ein Abgleich gleichzeitig; eigene Änderungen lösen keine weiteren Events aus (keine Schleifen). */
  var GIFT_KEY = 'tibetiaGiftState';
  var syncBusy = false;
  var syncAgain = false;
  var syncTimer = null;
  var syncFails = 0;      // aufeinanderfolgende Netzfehler beim Abgleich (max. 4 Wiederholungen)
  var watchdogTimer = null;

  function readConfig() {
    var el = document.querySelector('script[data-tibetia-cart-config]');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  function getGiftState() {
    try { return window.sessionStorage.getItem(GIFT_KEY) || ''; } catch (e) { return ''; }
  }

  function setGiftState(value) {
    try {
      if (value) window.sessionStorage.setItem(GIFT_KEY, value);
      else window.sessionStorage.removeItem(GIFT_KEY);
    } catch (e) {}
    document.documentElement.setAttribute('data-tibetia-gift', value || '');
  }

  function sectionIds() {
    var ids = [];
    var drawer = document.querySelector('cart-drawer');
    var cartItems = document.querySelector('cart-items');
    if (drawer) ids.push('cart-drawer');
    ids.push('cart-icon-bubble');
    if (cartItems && typeof cartItems.getSectionsToRender === 'function') {
      cartItems.getSectionsToRender().forEach(function (s) { if (s.section) ids.push(s.section); });
    }
    return ids.filter(function (id, i) { return ids.indexOf(id) === i; });
  }

  // Bereiche neu einsetzen, ohne den Drawer zu öffnen (ist er offen, bleibt er offen)
  function applySections(sections, itemCount) {
    if (!sections) return;
    var drawer = document.querySelector('cart-drawer');
    if (drawer && sections['cart-drawer']) {
      var src = parseHTML(sections['cart-drawer'], '#CartDrawer');
      var target = drawer.querySelector('#CartDrawer');
      if (src && target) {
        target.innerHTML = src.innerHTML;
        var overlay = drawer.querySelector('#CartDrawer-Overlay');
        if (overlay && typeof drawer.close === 'function') overlay.addEventListener('click', drawer.close.bind(drawer));
        drawer.classList.toggle('is-empty', !!src.querySelector('.drawer__inner-empty'));
      }
    }
    var bubble = document.getElementById('cart-icon-bubble');
    if (bubble && sections['cart-icon-bubble']) {
      var b = parseHTML(sections['cart-icon-bubble'], '.shopify-section');
      if (b) bubble.innerHTML = b.innerHTML;
    }
    var cartItems = document.querySelector('cart-items');
    if (cartItems && typeof cartItems.getSectionsToRender === 'function') {
      renderPage(cartItems, { sections: sections });
      if (itemCount === 0) {
        cartItems.classList.add('is-empty');
        var footer = document.getElementById('main-cart-footer');
        if (footer) footer.classList.add('is-empty');
      }
    }
  }

  function cartRequest(path, body) {
    body.sections = sectionIds();
    body.sections_url = window.location.pathname;
    return fetch(rootUrl() + path, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
      .then(function (res) {
        if (!res.ok || res.data.status) throw new Error(res.data.description || res.data.message || 'Fehler');
        applySections(res.data.sections, typeof res.data.item_count === 'number' ? res.data.item_count : null);
        timerRefresh();
        return res.data;
      });
  }

  function setLines(keys, quantity) {
    var updates = {};
    keys.forEach(function (k) { updates[k] = quantity; });
    return cartRequest('cart/update.js', { updates: updates });
  }

  function runSync() {
    var cfg = readConfig();
    if (!cfg || !cfg.kalenderHandle) return;
    if (syncBusy) { syncAgain = true; return; }
    syncBusy = true;
    fetch(rootUrl() + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        syncFails = 0;
        var basis = 0;
        var autos = [];
        var bought = 0;
        (cart.items || []).forEach(function (it) {
          if (it.handle === cfg.kalenderHandle) {
            if (it.properties && it.properties._tibetia_geschenk === 'auto') autos.push(it);
            else bought += it.quantity;
          } else {
            basis += cfg.basis === 'nach_rabatt' ? it.final_line_price : it.original_line_price;
          }
        });
        var state = getGiftState();
        var eligible = !!cfg.aktiv && basis >= cfg.schwelle;

        if (!eligible) {
          if (state) setGiftState('');
          if (autos.length) return setLines(autos.map(function (a) { return a.key; }), 0);
          return null;
        }
        if (bought > 0) {
          if (state) setGiftState('');
          if (autos.length) return setLines(autos.map(function (a) { return a.key; }), 0);
          return null;
        }
        if (autos.length) {
          if (state !== 'auto') setGiftState('auto');
          if (autos.length > 1) return setLines(autos.slice(1).map(function (a) { return a.key; }), 0);
          if (autos[0].quantity > 1) return setLines([autos[0].key], 1);
          return null;
        }
        // kein Kalender im Warenkorb, Schwelle erreicht
        if (state === 'auto') { setGiftState('declined'); return null; }
        if (state === 'declined') return null;
        if (!cfg.verfuegbar || !cfg.variantId) return null;
        return cartRequest('cart/add.js', {
          items: [{ id: cfg.variantId, quantity: 1, properties: { _tibetia_geschenk: 'auto' } }]
        })
          .then(function () { setGiftState('auto'); })
          .catch(function () { setGiftState('failed'); });
      })
      .catch(function () {
        // Netzfehler (z. B. abgebrochene Anfrage auf dem iPhone): kurz warten und erneut abgleichen
        syncFails += 1;
        if (syncFails <= 4) syncAgain = true;
      })
      .then(function () {
        syncBusy = false;
        if (syncAgain) {
          syncAgain = false;
          clearTimeout(syncTimer);
          syncTimer = setTimeout(runSync, syncFails ? 1200 : 250);
        }
      });
  }

  function scheduleSync() {
    clearTimeout(syncTimer);
    syncTimer = setTimeout(runSync, 250);
    armWatchdog();
  }

  /* Absicherung: Zeigt der Warenkorb nach 5 s immer noch „Kalender fehlt“ (Knopf vom Server gerendert) und läuft
     kein automatischer Vorgang mehr, wird der Zustand 'failed' gesetzt -> Hinweis „fehlt noch“ + Knopf sichtbar,
     und es folgt ein weiterer Versuch. */
  function armWatchdog() {
    clearTimeout(watchdogTimer);
    watchdogTimer = setTimeout(function () {
      if (!document.querySelector('.tcp__gift-button')) return;
      var state = getGiftState();
      if (state === 'declined' || state === 'failed') return;
      setGiftState('failed');
      clearTimeout(syncTimer);
      syncTimer = setTimeout(runSync, 50);
    }, 5000);
  }

  document.documentElement.setAttribute('data-tibetia-gift', getGiftState());

  // Auslöser 1: jede Warenkorbänderung über Dawns PubSub (Produktformular, Mengen/Entfernen, Empfehlungen)
  if (typeof window.subscribe === 'function' && pubEvents()) {
    window.subscribe(pubEvents().cartUpdate, function () { scheduleSync(); });
  }
  // Auslöser 2: Öffnen des Drawers (auch nach renderContents / Raunacht-Kauflogik)
  if (window.customElements && customElements.whenDefined) {
    customElements.whenDefined('cart-drawer').then(function () {
      var C = customElements.get('cart-drawer');
      if (!C || C.prototype.__tibetiaPatched) return;
      var originalOpen = C.prototype.open;
      C.prototype.open = function () {
        var result = originalOpen.apply(this, arguments);
        scheduleSync();
        return result;
      };
      C.prototype.__tibetiaPatched = true;
    });
  }
  // Auslöser 3: Laden der Warenkorb-Seite
  if (/\/cart\/?$/.test(window.location.pathname)) scheduleSync();
  // Auslöser 4: Seite kommt aus dem Zurück-Cache (iPhone Safari) oder Tab wird wieder sichtbar
  window.addEventListener('pageshow', function (event) {
    if (event.persisted) { scheduleSync(); timerRefresh(); }
  });
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible' && document.querySelector('.tcp__gift-button')) scheduleSync();
  });

  /* ================= Lieferdatum (Europe/Berlin) =================
     Bestellung Mo–Fr vor data-cutoff Uhr → Versand heute, sonst am nächsten Werktag (Mo–Fr, kein Feiertag).
     Zustellung nach data-min bis data-max Zustelltagen (Mo–Sa, kein Feiertag). Ohne JS bleibt der Text aus Liquid stehen. */
  var HOLIDAYS = {
    '2026-01-01': 1, '2026-04-03': 1, '2026-04-06': 1, '2026-05-01': 1, '2026-05-14': 1, '2026-05-25': 1,
    '2026-10-03': 1, '2026-12-25': 1, '2026-12-26': 1,
    '2027-01-01': 1, '2027-03-26': 1, '2027-03-29': 1, '2027-05-01': 1, '2027-05-06': 1, '2027-05-17': 1,
    '2027-10-03': 1, '2027-12-25': 1, '2027-12-26': 1
  };
  var WEEKDAYS = ['So.', 'Mo.', 'Di.', 'Mi.', 'Do.', 'Fr.', 'Sa.'];

  function berlinNow() {
    try {
      var parts = new Intl.DateTimeFormat('en-CA', {
        timeZone: 'Europe/Berlin', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', hourCycle: 'h23'
      }).formatToParts(new Date());
      var v = {};
      parts.forEach(function (p) { v[p.type] = p.value; });
      return { date: new Date(Date.UTC(+v.year, +v.month - 1, +v.day)), hour: +v.hour };
    } catch (e) {
      var d = new Date();
      return { date: new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate())), hour: d.getHours() };
    }
  }
  function key(d) { return d.toISOString().slice(0, 10); }
  function addDay(d) { return new Date(d.getTime() + 86400000); }
  function isShipDay(d) { var w = d.getUTCDay(); return w >= 1 && w <= 5 && !HOLIDAYS[key(d)]; }
  function isDeliveryDay(d) { var w = d.getUTCDay(); return w >= 1 && w <= 6 && !HOLIDAYS[key(d)]; }
  function fmt(d) { return WEEKDAYS[d.getUTCDay()] + ' ' + d.getUTCDate() + '.' + (d.getUTCMonth() + 1) + '.'; }

  function deliveryWindow(cutoff, min, max) {
    var now = berlinNow();
    var ship = now.date;
    if (!(isShipDay(ship) && now.hour < cutoff)) {
      ship = addDay(ship);
      while (!isShipDay(ship)) ship = addDay(ship);
    }
    var d = ship, n = 0, from = null;
    while (n < max) {
      d = addDay(d);
      if (isDeliveryDay(d)) {
        n += 1;
        if (n === min) from = d;
      }
    }
    return { from: from || d, to: d };
  }

  function updateDelivery(root) {
    (root || document).querySelectorAll('[data-tibetia-delivery]:not([data-ready])').forEach(function (el) {
      var cutoff = parseInt(el.dataset.cutoff, 10);
      var min = parseInt(el.dataset.min, 10) || 1;
      var max = parseInt(el.dataset.max, 10) || 3;
      if (isNaN(cutoff)) cutoff = 14;
      var w = deliveryWindow(cutoff, min, Math.max(min, max));
      el.innerHTML = 'Lieferung: <strong>' + fmt(w.from) +
        (w.to.getTime() !== w.from.getTime() ? '–' + fmt(w.to) : '') + '</strong>';
      el.setAttribute('data-ready', '');
    });
  }

  /* Express-Kasse: Dawns Mengen-Änderungen holen die Bereiche mit „Accept: application/json“ – dann liefert Shopify
     die Express-Knöpfe leer aus. Leeren Container einmalig ohne diesen Header nachladen (nur eine Anfrage gleichzeitig). */
  var expressBusy = false;
  function refillExpress() {
    var sel = 'cart-drawer .tcs__express .additional-checkout-buttons';
    var c = document.querySelector(sel);
    if (!c || c.children.length || expressBusy) return;
    expressBusy = true;
    fetch(rootUrl() + '?sections=cart-drawer', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        var src = parseHTML((j && j['cart-drawer']) || '', '.tcs__express .additional-checkout-buttons');
        var cur = document.querySelector(sel);
        if (src && cur && !cur.children.length && src.children.length) cur.innerHTML = src.innerHTML;
      })
      .catch(function () {})
      .then(function () { expressBusy = false; });
  }

  /* Nach jedem Neu-Rendern (Dawn oder eigene Logik): Lieferdatum setzen, Express-Kasse neu initialisieren */
  var paintTimer = null;
  var seenExpress = window.WeakSet ? new WeakSet() : null;
  function afterRender() {
    clearTimeout(paintTimer);
    paintTimer = setTimeout(function () {
      updateDelivery();
      refillExpress();
      // Express-Kasse nur neu initialisieren, wenn ein NEUER Container eingesetzt wurde (keine Endlosschleife)
      var fresh = false;
      document.querySelectorAll('cart-drawer .additional-checkout-buttons').forEach(function (el) {
        if (seenExpress && !seenExpress.has(el)) { seenExpress.add(el); fresh = true; }
      });
      if (!fresh) return;
      try {
        if (window.Shopify && window.Shopify.PaymentButton && typeof window.Shopify.PaymentButton.init === 'function') {
          window.Shopify.PaymentButton.init();
        }
      } catch (e) {}
    }, 60);
  }
  document.querySelectorAll('cart-drawer .additional-checkout-buttons').forEach(function (el) {
    if (seenExpress) seenExpress.add(el);
  });
  updateDelivery();
  if (window.MutationObserver) {
    new MutationObserver(function (records) {
      for (var i = 0; i < records.length; i++) {
        var t = records[i].target;
        if (t && t.closest && (t.closest('cart-drawer') || t.closest('#main-cart-footer') || t.closest('cart-items'))) {
          afterRender();
          return;
        }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  /* Express-Kasse: nur EIN Knopf zeigen („tcx“).
     Rangfolge: Apple Pay > Google Pay > PayPal > Shop Pay – nur was Shopify für dieses Gerät wirklich rendert.
     Die anderen bleiben im DOM (data-tcx-hide, per CSS nur visuell versteckt). Die Knöpfe kommen asynchron als
     Kinder von <shopify-accelerated-checkout-cart> (slot="button-ApplePay|GooglePay|PayPal|ShopPay"); Beobachter
     wendet die Regel nach jedem Rendern an. Absicherung: Ohne Erkennung zeigt das CSS das erste Kind, ein Knopf
     mit Größe 0 (nicht verfügbar) wird nach ca. 2,5 s übersprungen, der letzte bleibt immer stehen. */
  var XP_RANK = [/apple/i, /google/i, /paypal/i, /shop.?pay/i];
  var XP_WAIT = 10000;
  var xpFirstSeen = window.WeakMap ? new WeakMap() : null;
  var xpZeroSince = window.WeakMap ? new WeakMap() : null;
  var xpDead = window.WeakSet ? new WeakSet() : null;
  var xpTimer = null;

  function xpRank(el) {
    var key = el.getAttribute('slot') || el.tagName || '';
    for (var i = 0; i < XP_RANK.length; i++) if (XP_RANK[i].test(key)) return i;
    return 9;
  }

  function xpCandidates(host) {
    var out = [];
    var kids = host ? host.children : [];
    for (var i = 0; i < kids.length; i++) {
      var k = kids[i];
      if (/^(STYLE|SCRIPT|TEMPLATE)$/.test(k.tagName)) continue;
      out.push(k);
    }
    var buttons = out.filter(function (k) {
      return /^button-/i.test(k.getAttribute('slot') || '') || /button/i.test(k.tagName);
    });
    return buttons.length ? buttons : out;
  }

  var xpFitKey = window.WeakMap ? new WeakMap() : null;
  // Gewählten Knopf über die volle Breite ziehen (Shopify setzt ihn sonst in seine Spalte/Zeile)
  function xpFit(c, win) {
    try {
      if (!c.getClientRects().length) return;
      var cw = Math.round(c.getBoundingClientRect().width);
      if (cw < 40) return;
      var key = cw + '|' + (win.getAttribute('slot') || win.tagName);
      if (xpFitKey && xpFitKey.get(c) === key && c.hasAttribute('data-tcx-fit')) return;
      c.removeAttribute('data-tcx-fit'); // statische Position messen
      var cr = c.getBoundingClientRect();
      var wr = win.getBoundingClientRect();
      if (wr.width < 2 || wr.height < 2) return; // noch nicht geladen – später erneut
      c.style.setProperty('--tcx-x', Math.round(wr.left - cr.left) + 'px');
      c.style.setProperty('--tcx-y', Math.round(wr.top - cr.top) + 'px');
      c.style.setProperty('--tcx-w', cw + 'px');
      c.style.setProperty('--tcx-h', Math.max(40, Math.round(wr.height)) + 'px');
      c.setAttribute('data-tcx-fit', '');
      if (xpFitKey) xpFitKey.set(c, key);
    } catch (e) {
      c.removeAttribute('data-tcx-fit');
    }
  }
  var xpResize = window.ResizeObserver ? new ResizeObserver(function () { xpSchedule(60); }) : null;
  var xpWatched = window.WeakSet ? new WeakSet() : null;

  function xpApply(c) {
    try {
      var now = Date.now();
      if (xpFirstSeen && !xpFirstSeen.has(c)) xpFirstSeen.set(c, now);
      var host = c.querySelector('shopify-accelerated-checkout-cart');
      var cands = xpCandidates(host);
      if (!cands.length) {
        // noch nicht geladen: Platz bleibt reserviert; erst nach dem Zeitlimit einklappen
        if (xpFirstSeen && now - xpFirstSeen.get(c) > XP_WAIT) c.setAttribute('data-tcx-empty', '');
        return false;
      }
      c.removeAttribute('data-tcx-empty');
      var alive = cands.filter(function (k) { return !(xpDead && xpDead.has(k)); });
      if (!alive.length) alive = cands.slice(0, 1);
      var order = alive.map(function (k, i) { return { k: k, r: xpRank(k), i: i }; })
        .sort(function (a, b) { return a.r - b.r || a.i - b.i; });
      var win = order[0].k;
      cands.forEach(function (k) {
        if (k === win) {
          k.removeAttribute('data-tcx-hide');
          k.removeAttribute('inert');
          k.removeAttribute('aria-hidden');
          k.setAttribute('data-tcx-show', '');
        } else {
          k.setAttribute('data-tcx-hide', '');
          k.setAttribute('inert', '');
          k.setAttribute('aria-hidden', 'true');
          k.removeAttribute('data-tcx-show');
        }
      });
      c.setAttribute('data-tcx', (win.getAttribute('slot') || win.tagName).toLowerCase());
      if (xpResize && xpWatched && !xpWatched.has(c)) { xpWatched.add(c); xpResize.observe(c); }
      xpFit(c, win);
      // Ist der gewählte Knopf (sichtbar eingeblendeter Container) leer geblieben? Dann den nächsten nehmen.
      var pending = false;
      if (xpDead && xpZeroSince && c.getClientRects().length && order.length > 1) {
        var r = win.getBoundingClientRect();
        if (r.width < 2 || r.height < 2) {
          if (!xpZeroSince.has(win)) xpZeroSince.set(win, now);
          if (now - xpZeroSince.get(win) > 2500) { xpDead.add(win); return xpApply(c); }
          pending = true;
        } else {
          xpZeroSince.delete(win);
        }
      }
      return pending;
    } catch (e) {
      return false; // Fehler: CSS-Fallback (erstes Kind) bleibt wirksam
    }
  }

  function xpScan() {
    var pending = false;
    document.querySelectorAll('.additional-checkout-buttons').forEach(function (c) {
      if (xpApply(c)) pending = true;
    });
    if (pending) xpSchedule(800);
  }

  function xpSchedule(delay) {
    clearTimeout(xpTimer);
    xpTimer = setTimeout(xpScan, delay || 40);
  }

  xpScan();
  [250, 700, 1500, 3000, 6000, XP_WAIT + 300].forEach(function (d) { setTimeout(xpScan, d); });
  if (window.MutationObserver) {
    new MutationObserver(function (records) {
      for (var i = 0; i < records.length; i++) {
        var t = records[i].target;
        if (t && t.closest && t.closest('.additional-checkout-buttons, .tcs__express, cart-drawer, #main-cart-footer')) {
          xpSchedule(40);
          return;
        }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  /* ================= Reservierungs-Timer =================
     <tibetia-cart-timer> (Drawer + /cart, Markup: snippets/tibetia-cart-progress.liquid, part 'timer').
     - Ablaufzeitpunkt + Artikelzahl (ohne Gratis-Geschenk) liegen in localStorage (Schlüssel tibetiaCartTimer),
       damit Drawer, /cart-Seite, Neuladen und weitere Tabs denselben Stand zeigen. Ohne Speicher: einfacher
       Countdown im Arbeitsspeicher (beginnt nach Seitenwechsel neu).
     - Start: Warenkorb nicht leer. Neustart bei 10:00: mehr Artikel als zuvor. Leerer Warenkorb: Stand gelöscht.
     - Abgelaufen: rote Leiste bleibt stehen. Screenreader: aria-live nur beim Wechsel auf „abgelaufen“. */
  var TIMER_KEY = 'tibetiaCartTimer';
  var TIMER_MS = 10 * 60 * 1000;
  var TIMER_EXPIRED_TEXT = 'Reservierung abgelaufen - Artikel könnten nicht mehr verfügbar sein';
  var TIMER_ICON_CLOCK = '<svg viewBox="0 0 16 16" focusable="false" fill="none"><circle cx="8" cy="8" r="8" fill="currentColor"/><path d="M8 4.1V8l2.6 1.7" stroke="#fff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var TIMER_ICON_ALERT = '<svg viewBox="0 0 16 16" focusable="false" fill="none"><circle cx="8" cy="8" r="8" fill="currentColor"/><path d="M8 4v4.6" stroke="#fff" stroke-width="1.7" stroke-linecap="round"/><circle cx="8" cy="11.6" r="1" fill="#fff"/></svg>';
  var timerMem = null;
  var timerStorageOk = false;
  try {
    window.localStorage.setItem('__tct', '1');
    timerStorageOk = window.localStorage.getItem('__tct') === '1';
    window.localStorage.removeItem('__tct');
  } catch (e) { timerStorageOk = false; }

  function timerRead() {
    if (!timerStorageOk) return timerMem;
    try {
      var raw = window.localStorage.getItem(TIMER_KEY);
      if (!raw) return null;
      var s = JSON.parse(raw);
      if (s && typeof s.exp === 'number' && typeof s.count === 'number') return s;
    } catch (e) {}
    return null;
  }

  function timerWrite(s) {
    timerMem = s;
    if (!timerStorageOk) return;
    try { window.localStorage.setItem(TIMER_KEY, JSON.stringify(s)); } catch (e) {}
  }

  function timerClear() {
    timerMem = null;
    if (!timerStorageOk) return;
    try { window.localStorage.removeItem(TIMER_KEY); } catch (e) {}
  }

  function timerSync(count) {
    count = Number(count) || 0;
    var s = timerRead();
    if (count <= 0) { if (s) timerClear(); return null; }
    var now = Date.now();
    if (!s || count > s.count) s = { exp: now + TIMER_MS, count: count };
    else if (count < s.count) s = { exp: s.exp, count: count };
    else return s;
    timerWrite(s);
    return s;
  }

  function timerPad(n) { return (n < 10 ? '0' : '') + n; }

  function timerCountNonGift(cart) {
    var n = 0;
    (cart.items || []).forEach(function (it) {
      if (!(it.final_line_price === 0 && it.original_line_price > 0)) n += it.quantity;
    });
    return n;
  }

  var timerRefreshTimer = null;
  function timerRefresh() {
    if (!TIBETIA_CART_TIMER) return;
    clearTimeout(timerRefreshTimer);
    timerRefreshTimer = setTimeout(function () {
      fetch(rootUrl() + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var count = timerCountNonGift(cart);
          document.querySelectorAll('tibetia-cart-timer').forEach(function (el) {
            if (typeof el.sync === 'function') el.sync(count);
          });
        })
        .catch(function () {});
    }, 150);
  }

  if (TIBETIA_CART_TIMER && !customElements.get('tibetia-cart-timer')) {
    customElements.define(
      'tibetia-cart-timer',
      class extends HTMLElement {
        connectedCallback() {
          this.sync();
        }
        disconnectedCallback() {
          this.stopTicking();
        }
        stopTicking() {
          if (this._t) { clearInterval(this._t); this._t = null; }
        }
        sync(count) {
          if (count === undefined) count = parseInt(this.dataset.count, 10) || 0;
          else this.dataset.count = String(count);
          if (count <= 0) {
            this.hidden = true;
            this.stopTicking();
            timerSync(0);
            this.setAttribute('data-ready', '');
            return;
          }
          timerSync(count);
          this.hidden = false;
          this.tick();
          this.setAttribute('data-ready', '');
          if (!this._t) {
            var self = this;
            this._t = setInterval(function () { self.tick(); }, 1000);
          }
        }
        tick() {
          var s = timerRead() || timerSync(parseInt(this.dataset.count, 10) || 0);
          if (!s) return;
          var remaining = Math.max(0, s.exp - Date.now());
          var expired = remaining <= 0;
          var state = expired ? 'expired' : 'running';
          var text = this.querySelector('[data-tct-text]');
          var icon = this.querySelector('[data-tct-icon]');
          var live = this.querySelector('[data-tct-live]');
          if (this.getAttribute('data-state') !== state || !this._painted) {
            var previous = this._painted ? this.getAttribute('data-state') : null;
            this.setAttribute('data-state', state);
            this._painted = true;
            if (icon) icon.innerHTML = expired ? TIMER_ICON_ALERT : TIMER_ICON_CLOCK;
            if (text) {
              if (expired) text.textContent = TIMER_EXPIRED_TEXT;
              else text.innerHTML = 'Dein Warenkorb ist <strong class="tct__time" data-tct-time></strong> Min. reserviert';
            }
            // Vorlesen nur beim Wechsel von „läuft“ auf „abgelaufen“
            if (live) live.textContent = expired && previous === 'running' ? TIMER_EXPIRED_TEXT : '';
          }
          if (!expired) {
            var total = Math.ceil(remaining / 1000);
            var el = this.querySelector('[data-tct-time]');
            if (el) el.textContent = timerPad(Math.floor(total / 60)) + ':' + timerPad(total % 60);
          }
        }
      }
    );
    if (typeof window.subscribe === 'function' && pubEvents()) {
      window.subscribe(pubEvents().cartUpdate, function () { timerRefresh(); });
    }
  }


  /* ================= Sicher in den Warenkorb – immer Drawer, nie /cart =================
     safeAdd(body, form): legt Artikel per /cart/add.js in den Warenkorb und öffnet danach den Drawer.
     - body = { items: [...] } oder FormData eines Produktformulars
     - Antwort bricht ab (z. B. iPhone, schlechtes Netz)? Erst nachsehen, ob die Artikel angekommen sind. Wenn ja:
       Erfolg. Es wird NIE blind ein zweites Mal abgeschickt (früherer Fehler: doppelter Kamin).
     - Sagt der Shop ausdrücklich nein (z. B. ausverkauft), kommt die Meldung des Shops.
     Formulare mit action „/cart/add“, die kein anderes Script übernimmt, laufen automatisch hierüber.
     Landet doch jemand per Link/Weiterleitung auf /cart, schickt layout/theme.liquid ihn zurück (?warenkorb=offen). */
  var OPEN_PARAM = 'warenkorb';

  function withOpenParam(url) {
    var parts = String(url || '/').split('#');
    var clean = parts[0].replace(/([?&])warenkorb=[^&]*(&|$)/, function (m, a, b) { return b ? a : ''; }).replace(/[?&]$/, '');
    return clean + (clean.indexOf('?') > -1 ? '&' : '?') + OPEN_PARAM + '=offen';
  }

  function cartQuantities() {
    return fetch(rootUrl() + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error('cart'); return r.json(); })
      .then(function (cart) {
        var q = {};
        (cart.items || []).forEach(function (it) { q[it.variant_id] = (q[it.variant_id] || 0) + it.quantity; });
        return q;
      });
  }

  function wantedFrom(body) {
    var w = {};
    if (body && body.items) {
      body.items.forEach(function (it) { var id = Number(it.id); if (id) w[id] = (w[id] || 0) + (Number(it.quantity) || 1); });
    } else if (body && typeof body.get === 'function') {
      var id = Number(body.get('id'));
      if (id) w[id] = Number(body.get('quantity')) || 1;
    }
    return w;
  }

  function showDrawer() {
    return openDrawer().then(function () {
      if (typeof window.publish === 'function' && pubEvents()) {
        window.publish(pubEvents().cartUpdate, { source: 'tibetia-safe-add' });
      }
      scheduleSync();
      timerRefresh();
    });
  }

  function safeAdd(body, form) {
    var wanted = wantedFrom(body);
    var isForm = body && typeof body.get === 'function';
    var headers = { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' };
    if (!isForm) headers['Content-Type'] = 'application/json';
    return cartQuantities()
      .catch(function () { return null; })
      .then(function (before) {
        return fetch(rootUrl() + 'cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: headers,
          body: isForm ? body : JSON.stringify(body)
        })
          .then(function (r) {
            return r.json().catch(function () { return {}; }).then(function (d) {
              if (!r.ok || d.status) {
                var refusal = new Error(d.description || d.message || ERROR_TEXT);
                refusal.shopRefused = true;
                throw refusal;
              }
              return d;
            });
          })
          .catch(function (error) {
            if (error && error.shopRefused) throw error;
            // Antwort fehlt: nachsehen statt erneut abschicken
            return cartQuantities().then(function (after) {
              if (!before) return 'unklar';
              var angekommen = Object.keys(wanted).every(function (id) {
                return (after[id] || 0) >= (before[id] || 0) + wanted[id];
              });
              if (angekommen) return 'ok';
              var notAdded = new Error(ERROR_TEXT);
              notAdded.notAdded = true;
              throw notAdded;
            }, function () { return 'unklar'; });
          });
      })
      .then(function () {
        // Erfolg (oder Stand unklar): Drawer zeigt den echten Warenkorb – nichts wird doppelt hinzugefügt
        return showDrawer().catch(function () {
          window.location.href = withOpenParam(window.location.pathname + window.location.search);
        });
      });
  }

  function addError(form, error, allowNativeSubmit) {
    // Nur wenn sicher NICHTS angekommen ist und das Formular genau diese Artikel enthält: normal abschicken,
    // Rückkehr auf dieselbe Seite mit offenem Drawer (nicht /cart).
    if (error && error.notAdded && allowNativeSubmit && form) {
      var rt = form.querySelector('input[name="return_to"]');
      if (!rt) {
        rt = document.createElement('input');
        rt.type = 'hidden';
        rt.name = 'return_to';
        form.appendChild(rt);
      }
      rt.value = withOpenParam(window.location.pathname + window.location.search);
      HTMLFormElement.prototype.submit.call(form);
      return;
    }
    if (!form) return;
    var msg = (error && error.shopRefused && error.message) || ERROR_TEXT;
    var el = form.parentNode && form.parentNode.querySelector('.tc-add-error');
    if (!el) {
      el = document.createElement('p');
      el.className = 'tc-add-error';
      el.setAttribute('role', 'alert');
      el.style.cssText = 'margin:.6em 0 0;font-size:14px;line-height:1.4;color:#8a1c1c;';
      form.insertAdjacentElement('afterend', el);
    }
    el.textContent = msg;
  }

  function submitForm(form) {
    if (form.getAttribute('data-tc-busy') === '1') return;
    form.setAttribute('data-tc-busy', '1');
    var body = new FormData(form);
    var btn = form.querySelector('[type="submit"]');
    if (btn) { btn.setAttribute('aria-busy', 'true'); btn.disabled = true; }
    var fertig = function () {
      form.removeAttribute('data-tc-busy');
      if (btn) { btn.removeAttribute('aria-busy'); btn.disabled = false; btn.style.opacity = ''; }
    };
    var old = form.parentNode && form.parentNode.querySelector('.tc-add-error');
    if (old) old.textContent = '';
    safeAdd(body, form).then(fertig, function (error) { fertig(); addError(form, error, true); });
  }

  // Alle übrigen „In den Warenkorb“-Formulare (Bubble-Phase: eigene Scripts der Seiten laufen vorher und
  // können per preventDefault selbst übernehmen, z. B. Dawns Produktformular oder Upsell-Logik)
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (event.defaultPrevented || !form || form.tagName !== 'FORM') return;
    var action = form.getAttribute('action') || '';
    if (!/\/cart\/add(\.js)?(\?|$)/.test(action)) return;
    if (!window.fetch || !window.FormData || !document.querySelector('cart-drawer')) return;
    event.preventDefault();
    submitForm(form);
  });

  // ?warenkorb=offen: Drawer öffnen und den Parameter aus der Adresse entfernen
  (function openFromUrl() {
    if (!/[?&]warenkorb=offen(&|$)/.test(window.location.search)) return;
    try {
      var clean = window.location.search.replace(/([?&])warenkorb=offen(&|$)/, function (m, a, b) { return b ? a : ''; }).replace(/[?&]$/, '');
      window.history.replaceState(window.history.state, '', window.location.pathname + clean + window.location.hash);
    } catch (e) {}
    var go = function () { showDrawer().catch(function () {}); };
    if (window.customElements && customElements.whenDefined) {
      customElements.whenDefined('cart-drawer').then(function () { setTimeout(go, 0); });
    } else {
      go();
    }
  })();


  /* ================= Mengen ändern: Preis sofort anzeigen, kein Lade-Kreis =================
     Dawn lädt nach einer Mengenänderung den Warenkorb neu (~1 s Server). Bis dahin rechnet diese Funktion den
     Zeilenpreis sofort hoch (Stückpreis × neue Menge); Dawns Neu-Rendering ersetzt ihn danach mit dem echten Wert.
     Menge 0: Zeile wird sofort ausgegraut. Der Lade-Kreis ist per CSS ausgeblendet (assets/tibetia-cart.css). */
  function parseCents(text) {
    var m = String(text || '').replace(/\s/g, '').match(/(\d{1,3}(?:\.\d{3})+|\d+),(\d{2})/);
    return m ? parseInt(m[1].replace(/\./g, ''), 10) * 100 + parseInt(m[2], 10) : null;
  }
  function formatCents(cents) {
    try {
      return new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2).replace('.', ',') + ' €';
    }
  }
  document.addEventListener('change', function (event) {
    var input = event.target;
    if (!input || !input.classList || !input.classList.contains('quantity__input')) return;
    var row = input.closest('.cart-item');
    if (!row || !(input.closest('cart-drawer') || input.closest('cart-items'))) return;
    var prev = parseInt(input.getAttribute('data-tc-shown') || input.getAttribute('value'), 10);
    var next = parseInt(input.value, 10);
    if (!(prev > 0) || isNaN(next) || next === prev) return;
    if (next <= 0) {
      row.style.opacity = '0.35';
      row.style.transition = 'opacity .15s ease';
      var lineEl = row.querySelector('.tcd-item__price-now, .cart-item__price-wrapper > .price');
      var lineCents = lineEl && !(lineEl.closest('.cart-item__price-wrapper') || row).querySelector('s') ? parseCents(lineEl.textContent) : null;
      input.setAttribute('data-tc-shown', '0');
      if (lineCents !== null) optimisticTotals(input, -lineCents, -prev);
      return;
    }
    var unitCents = null;
    // nur Zeilen ohne Rabatt (bei Rabatten zeigt Dawn kurz den alten Preis bis zum Neu-Rendern)
    var targets = row.querySelectorAll('.tcd-item__price-now, .cart-item__price-wrapper > .price');
    Array.prototype.forEach.call(targets, function (el) {
      if (el.closest('.cart-item__discounted-prices')) return;
      var wrapper = el.closest('.cart-item__price-wrapper');
      if (wrapper && wrapper.querySelector('s')) return;
      var cents = parseCents(el.textContent);
      if (cents === null) return;
      unitCents = cents / prev;
      el.textContent = formatCents(Math.round(unitCents * next));
    });
    input.setAttribute('data-tc-shown', String(next)); // Dawn braucht das value-Attribut für Fehlerfälle
    if (unitCents !== null) optimisticTotals(input, Math.round(unitCents * (next - prev)), next - prev);
  }, true);

  /* Summe, Versand, Fortschrittsbalken und Zahl am Warenkorb-Symbol sofort mitrechnen (Shop bestätigt danach) */
  function optimisticTotals(input, deltaCents, deltaQty) {
    var drawer = input.closest('cart-drawer');
    var root = drawer || document;
    var totals = drawer ? drawer.querySelector('.tcs-totals') : document.querySelector('#main-cart-footer .tcs-totals');
    var cfg = readConfig() || {};
    var versandAb = cfg.versandAb || 7000;
    var versandKosten = cfg.versandKosten || 495;
    var geschenkAb = cfg.schwelle || 12000;
    var aktiv = !!cfg.aktiv;
    var subtotal = null;
    if (totals && !totals.querySelector('.tcs-row__old')) {
      var nowEl = totals.querySelector('.tcs-row__now');
      var shipEl = totals.querySelector('.tcs-row--ship .tcs-row__val');
      var summe = nowEl ? parseCents(nowEl.textContent) : null;
      if (summe !== null && shipEl) {
        var shipOld = /gratis/i.test(shipEl.textContent) ? 0 : (parseCents(shipEl.textContent) || 0);
        subtotal = Math.max(0, summe - shipOld + deltaCents);
        var shipNew = subtotal >= versandAb || subtotal === 0 ? 0 : versandKosten;
        nowEl.textContent = formatCents(subtotal + shipNew);
        if (shipNew === 0) {
          shipEl.textContent = 'GRATIS';
          shipEl.classList.add('tcs__free');
        } else {
          shipEl.textContent = formatCents(shipNew);
          shipEl.classList.remove('tcs__free');
        }
      }
    }
    if (subtotal !== null) {
      var prog = root.querySelector('tibetia-cart-progress');
      if (prog) {
        var p = aktiv
          ? (subtotal >= geschenkAb ? 1 : subtotal >= versandAb ? Math.max(subtotal / geschenkAb, versandAb / geschenkAb) : subtotal / geschenkAb)
          : subtotal / versandAb;
        p = Math.max(0, Math.min(1, p));
        var fill = prog.querySelector('[data-tcp-fill]');
        if (fill) fill.style.setProperty('--tcp-p', String(p));
        var mVersand = prog.querySelector('[data-tcp-milestone="versand"]');
        var mGeschenk = prog.querySelector('[data-tcp-milestone="geschenk"]');
        if (mVersand) mVersand.classList.toggle('is-reached', subtotal >= versandAb);
        if (mGeschenk) mGeschenk.classList.toggle('is-reached', aktiv && subtotal >= geschenkAb);
        var msg = prog.querySelector('.tcp__message');
        if (msg) {
          if (subtotal < versandAb) {
            msg.innerHTML = 'Noch <strong>' + formatCents(versandAb - subtotal) + '</strong> bis zum Gratis-Versand';
          } else if (aktiv && subtotal < geschenkAb) {
            msg.innerHTML = 'Gratis-Versand ist dabei. Noch <strong>' + formatCents(geschenkAb - subtotal) + '</strong> bis zu deinem gratis Adventskalender';
          } else if (aktiv && !msg.querySelector('.tcp__msg-pending') && /noch/i.test(msg.textContent)) {
            msg.innerHTML = '<strong>Gratis-Versand</strong> ist dabei – dein <strong>Räucher-Adventskalender</strong> wird hinzugefügt …';
          } else if (!aktiv) {
            msg.innerHTML = '<strong>Gratis-Versand</strong> ist dabei';
          }
        }
      }
    }
    // Zahl am Warenkorb-Symbol
    var bubble = document.querySelector('#cart-icon-bubble .cart-count-bubble span[aria-hidden="true"]');
    if (bubble) {
      var count = parseInt(bubble.textContent, 10);
      if (!isNaN(count)) bubble.textContent = String(Math.max(0, count + deltaQty));
    }
  }

  window.TibetiaCart = { add: add, openDrawer: openDrawer, syncGift: scheduleSync, safeAdd: safeAdd, addError: addError };
})();
